import { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import QuickSearch from "@/components/QuickSearch";
import About from "@/components/About";
import Properties from "@/components/Properties";
import Destinations from "@/components/Destinations";
import DirectBooking from "@/components/DirectBooking";
import Hospitality from "@/components/Hospitality";
import Testimonials from "@/components/Testimonials";
import BookingCTA from "@/components/BookingCTA";
import Booking from "@/components/Booking";
import CustomRequest from "@/components/CustomRequest";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import MobileBookBar from "@/components/MobileBookBar";
import { faq } from "@/data/site";

export default function Home() {
  useEffect(() => {
    document.title = "Martelli Rentals | Ville, appartamenti e soggiorni in Italia";
    // Dati strutturati FAQ generati dinamicamente
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "faq-jsonld";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faq.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    });
    document.head.appendChild(script);
    return () => { document.getElementById("faq-jsonld")?.remove(); };
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <QuickSearch />
        <About />
        <Properties />
        <Destinations />
        <DirectBooking />
        <Hospitality />
        <Testimonials />
        <BookingCTA />
        <Booking />
        <CustomRequest />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <MobileBookBar />
      <CookieBanner />
    </>
  );
}
